/**
 * @generated SignedSource<<c1de4fedc41af1eab44a2994e1e7bdfd>>
 * @relayHash 058111e5646edf5348443d111a1d1869
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5ebfb890dc2ea77f1954c8bc68a38dc92291639aa4276487e2a7c5c48ae77dd

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssignedSectionQuery$variables = {
  isEnabled: boolean;
  userId: string;
};
export type AssignedSectionQuery$data = {
  readonly graphStore?: {
    readonly " $fragmentSpreads": FragmentRefs<"getGoalsAssignedItems" | "getJiraAssignedItems" | "getProjectsAssignedItems" | "getPullRequestAssignedItems">;
  } | null;
};
export type AssignedSectionQuery = {
  response: AssignedSectionQuery$data;
  variables: AssignedSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "userId"
},
v3 = {
  "kind": "Literal",
  "name": "sort",
  "value": {
    "lastModified": {
      "direction": "DESC",
      "priority": 1
    }
  }
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "summary"
},
v6 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "mercuryName"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v11 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v12 = [
  (v1/*: any*/)
],
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  (v2/*: any*/),
  (v3/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "url"
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v16 = {
  "alias": "goalState",
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v15/*: any*/)
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v19 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v20 = [
  (v18/*: any*/),
  (v19/*: any*/)
],
v21 = {
  "alias": "projectState",
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v15/*: any*/)
},
v22 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  (v2/*: any*/),
  (v3/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    (v14/*: any*/),
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "lastUpdate"
    }
  ],
  "type": "ExternalPullRequest"
},
v25 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v23/*: any*/),
      (v24/*: any*/)
    ]
  }
],
v26 = [
  (v9/*: any*/)
],
v27 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v28 = [
  (v18/*: any*/),
  (v19/*: any*/),
  (v9/*: any*/)
],
v29 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v23/*: any*/),
      (v24/*: any*/),
      (v27/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": (v26/*: any*/),
        "type": "DevOpsPullRequestDetails"
      }
    ]
  },
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AssignedSectionQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "getJiraAssignedItems",
                "selections": [
                  {
                    "args": (v4/*: any*/),
                    "concreteType": "GraphStoreSimplifiedUserAssignedIssueConnection",
                    "kind": "LinkedField",
                    "name": "userAssignedIssue",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedUserAssignedIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "concreteType": "JiraDateTimePickerField",
                                    "kind": "LinkedField",
                                    "name": "updatedField",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "JiraStatusField",
                                    "kind": "LinkedField",
                                    "name": "statusField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "concreteType": "JiraStatusCategory",
                                            "kind": "LinkedField",
                                            "name": "statusCategory",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v10/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "JiraIssue"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "args": (v11/*: any*/),
                "argumentDefinitions": (v12/*: any*/)
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "getGoalsAssignedItems",
                "selections": [
                  {
                    "args": (v13/*: any*/),
                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasOwnerInverseConnection",
                    "kind": "LinkedField",
                    "name": "atlasGoalHasOwnerInverse",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedAtlasGoalHasOwnerInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  (v7/*: any*/),
                                  (v14/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "alias": "goalUpdates",
                                    "args": (v17/*: any*/),
                                    "concreteType": "TownsquareGoalUpdateConnection",
                                    "kind": "LinkedField",
                                    "name": "updates",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdateEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareGoalUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v20/*: any*/)
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "updates(first:1)"
                                  }
                                ],
                                "type": "TownsquareGoal"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "args": (v11/*: any*/),
                "argumentDefinitions": (v12/*: any*/)
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "getProjectsAssignedItems",
                "selections": [
                  {
                    "args": (v13/*: any*/),
                    "concreteType": "GraphStoreSimplifiedAtlasProjectHasOwnerInverseConnection",
                    "kind": "LinkedField",
                    "name": "atlasProjectHasOwnerInverse",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedAtlasProjectHasOwnerInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  (v7/*: any*/),
                                  (v14/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": "projectUpdates",
                                    "args": (v17/*: any*/),
                                    "concreteType": "TownsquareProjectUpdateConnection",
                                    "kind": "LinkedField",
                                    "name": "updates",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareProjectUpdateEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareProjectUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v20/*: any*/)
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "updates(first:1)"
                                  }
                                ],
                                "type": "TownsquareProject"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "args": (v11/*: any*/),
                "argumentDefinitions": (v12/*: any*/)
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "getPullRequestAssignedItems",
                "selections": [
                  {
                    "args": (v22/*: any*/),
                    "concreteType": "GraphStoreSimplifiedUserReviewsPrConnection",
                    "kind": "LinkedField",
                    "name": "userReviewsPr",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedUserReviewsPrEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v25/*: any*/)
                      }
                    ]
                  },
                  {
                    "args": (v22/*: any*/),
                    "concreteType": "GraphStoreSimplifiedUserAuthoredPrConnection",
                    "kind": "LinkedField",
                    "name": "userAuthoredPr",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedUserAuthoredPrEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v25/*: any*/)
                      }
                    ]
                  }
                ],
                "args": (v11/*: any*/),
                "argumentDefinitions": (v12/*: any*/)
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssignedSectionQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GraphStore",
            "kind": "LinkedField",
            "name": "graphStore",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "GraphStoreSimplifiedUserAssignedIssueConnection",
                "kind": "LinkedField",
                "name": "userAssignedIssue",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedUserAssignedIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              {
                                "concreteType": "JiraDateTimePickerField",
                                "kind": "LinkedField",
                                "name": "updatedField",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraStatusField",
                                "kind": "LinkedField",
                                "name": "statusField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      },
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v9/*: any*/)
                                ]
                              },
                              (v9/*: any*/),
                              (v10/*: any*/),
                              {
                                "concreteType": "JiraIssueTypeField",
                                "kind": "LinkedField",
                                "name": "issueTypeField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v9/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraProjectField",
                                "kind": "LinkedField",
                                "name": "projectField",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v10/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  },
                                  (v9/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v27/*: any*/)
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              {
                "args": (v13/*: any*/),
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasOwnerInverseConnection",
                "kind": "LinkedField",
                "name": "atlasGoalHasOwnerInverse",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasOwnerInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              (v7/*: any*/),
                              (v14/*: any*/),
                              (v16/*: any*/),
                              {
                                "alias": "goalUpdates",
                                "args": (v17/*: any*/),
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v28/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              }
                            ],
                            "type": "TownsquareGoal"
                          },
                          (v27/*: any*/)
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              {
                "args": (v13/*: any*/),
                "concreteType": "GraphStoreSimplifiedAtlasProjectHasOwnerInverseConnection",
                "kind": "LinkedField",
                "name": "atlasProjectHasOwnerInverse",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasProjectHasOwnerInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              (v7/*: any*/),
                              (v14/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": "projectUpdates",
                                "args": (v17/*: any*/),
                                "concreteType": "TownsquareProjectUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareProjectUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v28/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:1)"
                              }
                            ],
                            "type": "TownsquareProject"
                          },
                          (v27/*: any*/)
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              {
                "args": (v22/*: any*/),
                "concreteType": "GraphStoreSimplifiedUserReviewsPrConnection",
                "kind": "LinkedField",
                "name": "userReviewsPr",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedUserReviewsPrEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v29/*: any*/)
                  }
                ]
              },
              {
                "args": (v22/*: any*/),
                "concreteType": "GraphStoreSimplifiedUserAuthoredPrConnection",
                "kind": "LinkedField",
                "name": "userAuthoredPr",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedUserAuthoredPrEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v29/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "058111e5646edf5348443d111a1d1869",
    "id": "e5ebfb890dc2ea77f1954c8bc68a38dc92291639aa4276487e2a7c5c48ae77dd",
    "metadata": {},
    "name": "AssignedSectionQuery",
    "operationKind": "query",
    "text": "query AssignedSectionQuery(\n  $userId: ID!\n  $isEnabled: Boolean!\n) {\n  graphStore @include(if: $isEnabled) @optIn(to: \"GraphStore\") {\n    ...getJiraAssignedItems_1xxw8p\n    ...getGoalsAssignedItems_1xxw8p\n    ...getProjectsAssignedItems_1xxw8p\n    ...getPullRequestAssignedItems_1xxw8p\n  }\n}\n\nfragment getGoalsAssignedItems_1xxw8p on GraphStore {\n  atlasGoalHasOwnerInverse(id: $userId, first: 25, sort: {lastModified: {direction: DESC, priority: 1}}) @optIn(to: \"GraphStoreAtlasGoalHasOwner\") {\n    edges {\n      node {\n        __typename\n        ... on TownsquareGoal {\n          id\n          name\n          url\n          goalState: state {\n            value\n            label\n          }\n          goalUpdates: updates(first: 1) @optIn(to: \"Townsquare\") {\n            edges {\n              node {\n                creationDate\n                editDate\n                id\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment getJiraAssignedItems_1xxw8p on GraphStore {\n  userAssignedIssue(id: $userId, first: 50, sort: {lastModified: {direction: DESC, priority: 1}}) @optIn(to: \"GraphStoreUserAssignedIssue\") {\n    edges {\n      node {\n        __typename\n        ... on JiraIssue {\n          summary\n          updatedField {\n            dateTime\n            id\n          }\n          statusField {\n            status {\n              name\n              statusCategory {\n                mercuryName\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n          webUrl\n          issueTypeField {\n            issueType {\n              name\n              id\n            }\n            id\n          }\n          projectField {\n            project {\n              name\n              webUrl\n              id\n            }\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment getProjectsAssignedItems_1xxw8p on GraphStore {\n  atlasProjectHasOwnerInverse(id: $userId, first: 25, sort: {lastModified: {direction: DESC, priority: 1}}) @optIn(to: \"GraphStoreAtlasProjectHasOwner\") {\n    edges {\n      node {\n        __typename\n        ... on TownsquareProject {\n          id\n          name\n          url\n          projectState: state {\n            value\n            label\n          }\n          projectUpdates: updates(first: 1) @optIn(to: \"Townsquare\") {\n            edges {\n              node {\n                creationDate\n                editDate\n                id\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment getPullRequestAssignedItems_1xxw8p on GraphStore {\n  userReviewsPr(id: $userId, sort: {lastModified: {direction: DESC, priority: 1}}, first: 100) @optIn(to: \"GraphStoreUserReviewsPr\") {\n    edges {\n      node {\n        __typename\n        ... on ExternalPullRequest {\n          id\n          displayName\n          url\n          status\n          lastUpdate\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on DevOpsPullRequestDetails {\n          id\n        }\n      }\n      id\n    }\n  }\n  userAuthoredPr(id: $userId, sort: {lastModified: {direction: DESC, priority: 1}}, first: 100) @optIn(to: \"GraphStoreUserAuthoredPr\") {\n    edges {\n      node {\n        __typename\n        ... on ExternalPullRequest {\n          id\n          displayName\n          url\n          status\n          lastUpdate\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on DevOpsPullRequestDetails {\n          id\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "612dec725287bc9bb095c7bf82c3cdfa";

export default node;
